const path = `exams`;

export const state = {
	testStarted: false,
};

export const getters = {
	testStarted: () => sessionStorage.getItem("testStarted"),
};

export const mutations = {
	testStarted: (state, status) => {
		if (status == false && sessionStorage.getItem("testStarted")) {
			sessionStorage.removeItem("testStarted");
		} else sessionStorage.setItem("testStarted", status);
	},
};

export const actions = {
	// --- Generic Methods
	[`getAll`]() {
		return this._vm.$http.get(`/${path}`);
	},
	[`getAllSimple`]() {
		return this._vm.$http.get(`/${path}/simple`);
	},
	[`getAllOfExaminee`](store, { examineeId }) {
		return this._vm.$http.get(`/${path}/ofexaminee/${examineeId}`);
	},
	[`get`](store, { id }) {
		return this._vm.$http.get(`/${path}/${id}`);
	},
	[`create`](store, data) {
		return this._vm.$http.post(`/${path}`, data);
	},
	[`update`](store, { id, data }) {
		return this._vm.$http.put(`/${path}/${id}`, data);
	},
	[`delete`](store, { id }) {
		return this._vm.$http.delete(`/${path}/${id}`);
	},
	[`deleteAll`]() {
		return this._vm.$http.delete(`/${path}`);
	},
};
